<app-main-layout>
  <section class="dashboard-page" aria-label="Дашборд" data-dashboard-version="sales-analytics-v2">
    <div *ngIf="errorMessage" class="message error">
      {{ errorMessage }}
    </div>

    <div *ngIf="loading" class="loading-card">
      Загружаем аналитику...
    </div>

    <div class="metrics-grid" aria-label="Ключевые показатели">
      <article class="metric-card clients-metric">
        <div class="metric-topline">
          <span class="metric-label">Клиенты</span>
          <span class="metric-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          </span>
        </div>
        <strong>{{ clientsTotal }}</strong>
        <small><span class="metric-trend">↗ {{ activeClientsPercent }}%</span> активны</small>
        <svg class="sparkline" viewBox="0 0 320 76" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0 58C32 55 45 49 72 52C102 56 112 36 148 39C181 42 194 22 226 26C256 29 269 43 320 20"/>
        </svg>
      </article>

      <article class="metric-card tone-blue">
        <span class="metric-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
        </span>
        <span class="metric-label">Заказы</span>
        <strong>{{ orders.length }}</strong>
        <small>{{ paidOrders.length }} оплачено · {{ reservedOrdersTotal }} резерв</small>
      </article>

      <article class="metric-card tone-green">
        <span class="metric-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M3 3v18h18"/><path d="m19 9-5 5-4-4-3 3"/></svg>
        </span>
        <span class="metric-label">Выручка</span>
        <strong>{{ formatMoney(paidRevenue) }}</strong>
        <small>{{ formatMoney(reservedRevenue) }} в резерве</small>
      </article>

      <article class="metric-card tone-amber">
        <span class="metric-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M12 1v22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7H14a3.5 3.5 0 0 1 0 7H6"/></svg>
        </span>
        <span class="metric-label">Вложено</span>
        <strong>{{ formatMoney(investedTotal) }}</strong>
        <small>закупка + расходы</small>
      </article>
    </div>

    <div class="dashboard-grid">
      <article class="panel chart-panel">
        <div class="panel-heading">
          <div>
            <span class="eyebrow">Статистика</span>
            <h2>Динамика заказов</h2>
          </div>
          <span class="panel-badge">7 дней</span>
        </div>

        <div class="order-bars" aria-label="Динамика заказов за 7 дней">
          <div
            class="order-bar"
            *ngFor="let point of orderDynamics; trackBy: trackByBar"
          >
            <div class="bar-track">
              <span class="bar-fill" [style.height.%]="point.height"></span>
            </div>
            <strong>{{ point.ordersTotal }}</strong>
            <span>{{ point.label }}</span>
          </div>
        </div>
      </article>

      <article class="panel finance-panel">
        <div class="panel-heading">
          <div>
            <span class="eyebrow">Финансы</span>
            <h2>Продажи и затраты</h2>
          </div>
          <span class="panel-badge">Весь учет</span>
        </div>

        <div class="finance-list">
          <div class="finance-row">
            <span>Закупка всех билетов</span>
            <strong>{{ formatMoney(purchaseTotal) }}</strong>
          </div>
          <div class="finance-row">
            <span>Все расходы</span>
            <strong>{{ formatMoney(expenseTotal) }}</strong>
          </div>
          <div class="finance-row">
            <span>План после расходов</span>
            <strong>{{ formatMoney(plannedProfitTotal) }}</strong>
          </div>
          <div class="finance-row">
            <span>Маржа оплат</span>
            <strong>{{ formatMoney(actualTicketMargin) }}</strong>
          </div>
          <div class="finance-row accent">
            <span>Факт после расходов</span>
            <strong>{{ formatMoney(actualProfitAfterExpenses) }}</strong>
          </div>
          <p class="finance-note">Факт считается по оплаченным заказам: выручка минус закупка проданных билетов и расходы событий, где уже были оплаты.</p>
        </div>
      </article>

      <article class="panel list-panel">
        <div class="panel-heading">
          <div>
            <span class="eyebrow">Заказы</span>
            <h2>Последние заказы</h2>
          </div>
          <a routerLink="/dashboard/orders">Все</a>
        </div>

        <div class="compact-list" *ngIf="latestOrders.length; else emptyOrders">
          <a
            class="compact-row"
            *ngFor="let order of latestOrders; trackBy: trackById"
            [routerLink]="['/dashboard/orders', order.code || order.id]"
          >
            <div class="row-main">
              <strong>{{ order.code }}</strong>
              <span>{{ order.event?.name || 'Событие не указано' }}</span>
            </div>
            <div class="row-meta">
              <span class="status-chip" [class.paid]="order.status === 'paid'" [class.reserved]="order.status === 'reserved'">
                {{ getOrderStatusName(order) }}
              </span>
              <strong>{{ formatMoney(order.total) }}</strong>
              <time>{{ formatDate(order.createdAt) }}</time>
            </div>
          </a>
        </div>
        <ng-template #emptyOrders>
          <div class="empty-state">Заказов пока нет.</div>
        </ng-template>
      </article>

      <article class="panel list-panel">
        <div class="panel-heading">
          <div>
            <span class="eyebrow">CRM</span>
            <h2>Новые клиенты</h2>
          </div>
          <a routerLink="/dashboard/clients">Все</a>
        </div>

        <div class="compact-list" *ngIf="latestClients.length; else emptyClients">
          <a
            class="compact-row"
            *ngFor="let client of latestClients; trackBy: trackById"
            [routerLink]="['/dashboard/clients', client.publicIdentifier || client.id]"
          >
            <div class="row-main">
              <strong>{{ getClientName(client) }}</strong>
              <span>{{ client.owner?.displayName || client.owner?.username || 'Ответственный не указан' }}</span>
            </div>
            <div class="row-meta">
              <span class="status-chip" [class.paid]="client.status === 'active'">
                {{ client.status === 'active' ? 'Активен' : 'Не активен' }}
              </span>
              <time>{{ formatDate(client.createdAt) }}</time>
            </div>
          </a>
        </div>
        <ng-template #emptyClients>
          <div class="empty-state">Клиентов пока нет.</div>
        </ng-template>
      </article>

      <article class="panel insight-panel">
        <div class="panel-heading">
          <div>
            <span class="eyebrow">Клиент</span>
            <h2>Самый активный клиент</h2>
          </div>
          <span class="panel-badge">Все время</span>
        </div>

        <a
          *ngIf="mostActiveClient as client; else emptyActiveClient"
          class="insight-card"
          [routerLink]="['/dashboard/clients', client.routeId]"
        >
          <strong>{{ client.name }}</strong>
          <span>{{ client.ordersTotal }} покупок</span>
          <b>{{ formatMoney(client.revenue) }}</b>
        </a>
        <ng-template #emptyActiveClient>
          <div class="empty-state">Пока нет оплаченных заказов.</div>
        </ng-template>
      </article>

      <article class="panel insight-panel">
        <div class="panel-heading">
          <div>
            <span class="eyebrow">Матч</span>
            <h2>Лучший по показателям</h2>
          </div>
          <span class="panel-badge">Оплаты</span>
        </div>

        <a
          *ngIf="bestEvent as event; else emptyBestEvent"
          class="insight-card"
          [routerLink]="['/dashboard/events', event.routeId]"
        >
          <strong>{{ event.name }}</strong>
          <span>{{ formatDate(event.startsAt) }} · {{ event.ticketsTotal }} билетов</span>
          <b>{{ formatMoney(event.revenue || event.plannedProfit) }}</b>
        </a>
        <ng-template #emptyBestEvent>
          <div class="empty-state">Событий пока нет.</div>
        </ng-template>
      </article>
    </div>
  </section>
</app-main-layout>
